import { render, staticRenderFns } from "./addDriver.vue?vue&type=template&id=19205fd2&scoped=true&"
import script from "./addDriver.vue?vue&type=script&lang=js&"
export * from "./addDriver.vue?vue&type=script&lang=js&"
import style0 from "./addDriver.vue?vue&type=style&index=0&id=19205fd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19205fd2",
  null
  
)

export default component.exports